import {
  useClientTokenManager,
  useCurrentClientManager,
  useFeatureFlags,
} from '@cko/dashboard-shared';
import { FeatureFlagId } from '../../config/shared/enums/featureFlagIds';

const ENTITY_ONBOARDING_STATES = ['Draft', 'Pending', 'RequirementsDue'];

/**
 * Hook to check if the user is an Enterprise Merchant.
 *
 * For ease of development, the EnterpriseMerchantUserFlag will only
 * be enabled for testing. The flag will not be enabled in production.
 *
 * @returns boolean - whether the current user is an enterprise merchant.
 */
export const useIsOnboardingEnterpriseMerchant = () => {
  const { getFeatureFlag } = useFeatureFlags();
  const { client } = useCurrentClientManager();
  const { tokenProperties } = useClientTokenManager();

  const isEnterpriseOnboardingShellEnabled = getFeatureFlag(
    FeatureFlagId.ENTERPRISE_ONBOARDING_SHELL,
  );

  const isApplierRoleEnabled = getFeatureFlag(FeatureFlagId.REMOVE_APPLIER_ROLE);
  const isUserEnterpriseMerchant = getFeatureFlag(FeatureFlagId.ENTERPRISE_MERCHANT_USER);

  const [entity] = client?.entities?.length === 1 ? client.entities : [];

  const entityHasOnboardingStatus = ENTITY_ONBOARDING_STATES.includes(entity?.status ?? '');

  if (isApplierRoleEnabled) {
    return (
      isEnterpriseOnboardingShellEnabled && (isUserEnterpriseMerchant || entityHasOnboardingStatus)
    );
  }

  return (
    isEnterpriseOnboardingShellEnabled &&
    (isUserEnterpriseMerchant ||
      (entityHasOnboardingStatus && tokenProperties?.userRoles.includes('Applier')))
  );
};
